import { Fragment } from 'react';
import { Column, Text } from '~/commonComponents';
import { UserProfession } from '~/enums/UserProfession';
import { IJob, IUser, ProfessionTypeEnum } from '~/models';
import { Colors } from '~/themes/colors';
import { TNullable } from '~/types/Nullable';

interface IDnDaProceduresProps {
  job: TNullable<IJob>;
  professional: TNullable<IUser>;
}

export const DnDaProcedures = ({ job, professional }: IDnDaProceduresProps) => {
  const candidateEducation = professional?.professional_info?.education;
  const candidateProfession = professional?.license?.profession;
  const profession = (job?.profession || candidateProfession) as ProfessionTypeEnum;

  return (
    [UserProfession.DN, UserProfession.DA].includes(profession) && (
      <Column gap={16} marginTop={12}>
        {Object.keys(candidateEducation?.[profession]?.specialtiesAndProcedures || {})?.map(
          (name) => (
            <Fragment key={name}>
              <Text bold color={Colors.primary_500} fontSize={18} id={name}>
                {name?.split('_')?.[1]}
              </Text>

              <Column gap={4} marginTop={8}>
                {candidateEducation?.[profession]?.specialtiesAndProcedures?.[name]?.map((item) => (
                  <Text key={item}>{`\u2022  ${item?.split('_')?.[1]}`}</Text>
                ))}
              </Column>
            </Fragment>
          ),
        )}
      </Column>
    )
  );
};
